import React from "react";

const SupplementOptimizerHelp = () => (
  <div>
    <h2>Supplement Optimizer AI (Beta)</h2>
    <p>
      Want to optimize your supplement routine? This tool analyzes supplement safety, timing, interactions, and bioavailability to create a precise, ai-backed regimen. Here’s how to use it:
    </p>

    <h3>Getting Started</h3>
        <ol>
        <li>Select an input method: Single Entry or Bulk Mode.</li>
        <li>For Single Entry Mode:
            <ul>
            <li>Enter a supplement name in the input box.</li>
            <li>Enter the dosage and any additional notes.</li>
            <li>Use the "+" button to add more supplements or the trash icon to remove a row.</li>
            </ul>
        </li>
        <li>For Bulk Mode:
            <ul>
            <li>Toggle "Bulk Mode" using the checkbox.</li>
            <li>Enter multiple supplements in a comma-separated format, one per line.</li>
            <li>Format: <code>Supplement Name, Dosage, Notes</code></li>
            <li>Example: <code>Pro Health Resveratrol, 1000mg, Take in the morning</code></li>
            </ul>
        </li>
        <li>Click "Optimize Supplement" to receive a detailed analysis.</li>
        <li>Review the recommendations, including safety warnings, optimal timing, and food requirements.</li>
        </ol>
        <p><strong>Example (Single Entry Mode):</strong> Type "Magnesium Glycinate" or "Vitamin D3"</p>


    <h3>Features</h3>
    <ul>
      <li>Scientific Research-Based Analysis</li>
      <li>Bioavailability Assessment</li>
      <li>Interaction & Safety Checks</li>
      <li>Circadian Rhythm Optimization</li>
      <li>Absorption & Timing Guidance</li>
      <li>Food and Fat Requirements</li>
      <li>Supplement Cycling Recommendations</li>
      <li>Quality & Storage Considerations</li>
      <li>Long-Term Optimization Strategies</li>
    </ul>

    <h3>Understanding Results</h3>
    <h4>Key Analysis Categories</h4>
    <ul>
      <li><strong>Safety & Interactions:</strong> Checks for harmful combinations, medication conflicts, and dosage safety.</li>
      <li><strong>Timing & Bioavailability:</strong> Determines the best intake time based on absorption mechanisms and circadian rhythms.</li>
      <li><strong>Food & Fat Considerations:</strong> Identifies whether the supplement should be taken with food or on an empty stomach.</li>
      <li><strong>Quality & Storage:</strong> Provides guidance on supplement purity, sourcing, and ideal storage conditions.</li>
    </ul>

    <h3>Longevity Optimization</h3>
    <p>The tool offers personalized suggestions to maximize health benefits, including:</p>
    <ul>
      <li>Custom Daily Schedules</li>
      <li>Monthly Cycling Strategies</li>
      <li>Stacking & Synergistic Combinations</li>
      <li>Optimal Timing Separation</li>
      <li>Potential Side Effects & Risk Factors</li>
    </ul>

    <h3>Printing Results</h3>
    <h4>How to Print</h4>
    <ol>
      <li>Review the complete recommendations.</li>
      <li>Click the "Print View" button at the bottom of the results.</li>
      <li>Use your browser’s print function or system print dialog.</li>
    </ol>

    <p><strong>Note:</strong> Always consult with a healthcare professional before making major changes to your supplement routine.</p>
  </div>
);

export default SupplementOptimizerHelp;
